// SINGLE SOURCE OF TRUTH for Guardian colors.
// - JS/TS + SVG/canvas consumers import { guardianColors } from here.
// - The --guardianXXX CSS custom properties (scss/guardian/_color-tokens.scss) are GENERATED
//   from this file by scripts/generate-color-tokens.mjs (runs on build), so they never drift.
// For CSS/SCSS prefer var(--guardianXXX); use this map only where a CSS var can't be read.
export const guardianColors = {
    N00: '#fff',
    N10: '#f9f9f9',
    N20: '#f2f2f2',
    N30: '#eaeaea',
    N40: '#dedede',
    N45: '#cdcdcd',
    N50: '#c0c0c0',
    N55: '#7f7f7f',
    N60: '#5f5f5f',
    N70: '#393939',
    N80: '#1b1b1b',
    Black: '#000',

    P05: '#e7ccfa',
    P10: '#d099f5',
    P30: '#ad4ded',
    P50: '#8a00e5',
    P70: '#6100a0',
    P90: '#530984',

    MP50: '#641e8c',
    MP70: '#461562',

    SE10: '#9f9daa',
    SE30: '#5f5b71',
    SE40: '#322c48',
    SE50: '#1b1534',
    SE70: '#100d1f',

    WM10: '#a0cacc',
    WM30: '#7bb5b7',
    WM50: '#429698',
    WM60: '#357c7d',
    WM70: '#2e696a',
    WM90: '#214b4c',

    PP10: '#f5ecfa',
    PP30: '#e2ccf1',
    PP50: '#c4a0e2',

    R10: '#f0dcdc',
    R50: '#b20000',
    R70: '#8e0000',
    W50: '#f8bf86',
    W90: '#a9590a',

    Y10: '#fff6c7',
    Y20: '#ffef99',
    Y30: '#f6e600',
    Y70: '#c6ae00',
    Y90: '#806b00',

    B05: '#6addff',
    B10: '#c4d8f1',
    B20: '#96bfe9',
    B30: '#1cacfe',
    B40: '#2873bd',
    B50: '#0057c6',

    ST30: '#b8cedb',
    ST50: '#7b919d',

    E20: '#dbebd8',
    E50: '#b9d9b3',
    E90: '#528447',
    GR20: '#00fd79',
    GR30: '#14da79',
    GR50: '#099053',

    L01: '#1697f1',
    L02: '#92cf55',
    L03: '#ffe642',
    L04: '#ffa229',
    L05: '#f04a2d',

    DP10: '#ecebf9',
    DP30: '#cfccf1',
    PG30: '#d1fdd7',
    PG50: '#b1e3b9',
    BgGr10: '#dae6e1',
    BgMp10: '#f7f7fd',
} as const;

export type GuardianColorToken = keyof typeof guardianColors;
